import React, { useContext, useEffect, useRef } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { updateWallet } from '../../apis/geenpills/updateWallet';

import greenpillphantom from '../../assets/greenpill/greenpillphantom.png';
import { useLoadingState } from '../../hooks/useLoader';
import Overlay from '../../ui/Overlay';
import { toast } from 'sonner';
import { useWallet } from '@solana/wallet-adapter-react';

function PhantomConnection({ close, message }) {
    const wallet = useWallet();
    const myRef = useRef();
    const { loading, startLoading, stopLoading } = useLoadingState();
    const { state, dispatch } = useContext(AuthContext);
    const userProfile = state.user[0];
    const linkHandler = async () => {
        try {
            const phantom = wallet.wallets.find((w) => w.adapter.name === 'Phantom');
            if (!phantom || !phantom.adapter) {
                toast.error('Phantom wallet not found');
                return;
            }

            if (phantom.adapter?.name !== 'Phantom') {
                await wallet.select(phantom.adapter.name);
            }

            if (!phantom.adapter.connected) {
                await phantom.adapter.connect();
            }

            const publicKey = phantom.adapter.publicKey;
            if (!publicKey) {
                toast.error('Failed to get Phantom wallet address');
                return;
            }

            const newWallet = publicKey.toBase58();

            const response = await updateWallet(undefined, newWallet);
            if (response?.response?.data?.code === 400) {
                toast?.error(response?.response?.data?.message);
                return;
            }

            if (response?.walletAddress) {
                dispatch({ type: 'changeWalletSolana', payload: response?.walletAddress });
            }
        } catch (error) {
            console.error('Phantom Wallet Error:', error);
            toast.error('Error connecting to Phantom wallet');
        }
    };
    useEffect(
        function () {
            function handleClick(e) {
                if (myRef.current && !myRef.current.contains(e.target)) {
                    close();
                }
            }

            document.addEventListener('click', handleClick, true);

            return () => document.removeEventListener('click', handleClick, true);
        },
        [close]
    );
    return (
        <Overlay>
            <div
                ref={myRef}
                className="absolute rounded-lg left-[50%]  p-6   bg-grayBgNormal translate-x-[-50%] translate-y-[-50%] top-[50%]"
            >
                <div className="relative ">
                    <button
                        className=" absolute top-0 right-0  rounded-full  "
                        onClick={() => {
                            close();
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                            <circle cx="15" cy="15" r="15" fill="#F3F3F3" />
                            <path
                                d="M20.5918 10L10.5914 20.0004"
                                stroke="#B2B2B2"
                                strokeWidth="2"
                                strokeLinecap="round"
                            />
                            <path d="M20 20L9.99964 9.99964" stroke="#B2B2B2" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    </button>
                    <div className="flex items-center justify-center">
                        <h1
                            className="text-2xl font-semibold text-textPrimary "
                            style={{
                                textShadow: '0px 0px 11.8px rgba(255, 255, 255, 0.59)',
                            }}
                        >
                            <>No solana wallet linked to profile</>
                        </h1>
                    </div>
                    <p className="text-textSecondary mt-3 mb-6 text-center ">{message}</p>
                    <div className={`flex flex-col items-center gap-3 `}>
                        <button
                            onClick={() => linkHandler('phantom')}
                            type="button"
                            className={` px-4 py-2 flex items-center gap-2 rounded-md  w-[12.5rem] text-white bg-phantom-gradient  `}
                        >
                            <img className="w-7 h-7 object-cover rounded-full" src={greenpillphantom} alt="metamask" />
                            <span>
                                Link <span className="font-semibold">Phantom</span>{' '}
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </Overlay>
    );
}

export default PhantomConnection;
